export const STATUS_LABELS = {
  completed: "Tamamlandı",
  ongoing:   "Devam Ediyor",
  planning:  "Planlama",
};
